// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace utils.
 *
 * @category Workspace
 * @module js/swf3dWorkspaceUtils
 */
import config from 'js/swf3dWorkspaceConfig';

var swf3dWorkspaceUtils = {};

/**
 * Function for check if object is empty, null, or undefined.
 *
 * @memberof js/swf3dWorkspaceUtils
 * @function isPresent
 * @param {any} obj - any type of variable
 * @example
 * swf3dWorkspaceUtils.isPresent({});
 * @returns {boolean} - is present or not
 */
swf3dWorkspaceUtils.isPresent = function (obj) {
    return typeof obj !== 'undefined' && obj !== null && obj !== '';
};

/**
 * Function for check if type is valid.
 *
 * @memberof js/swf3dWorkspaceUtils
 * @function checkType
 * @param {string} type - valid type
 * @example
 * swf3dWorkspaceUtils.checkType('prt');
 * @returns {boolean} - is valid or not
 */
swf3dWorkspaceUtils.checkType = function (type) {
    if (true === config.validTypeList.includes(type)) {
        return true;
    }
    return false;
};

export default swf3dWorkspaceUtils;
